const LoadingDots = ({ text = '', color = 'gray', dotCount, styles }) => {
    const dotStyle = {
        display: 'inline-block',
        animation: 'bounce 0.6s infinite ease-in-out',
        transformOrigin: 'bottom',
        marginLeft: '2px',
    };

    return (
        <>
            <style>
                {`
            @keyframes bounce {
                0%, 80%, 100% { transform: translateY(0); }
                40% { transform: translateY(-5px); } //Control the height of the bounce
            }
        `}
            </style>
            <h5 className="RegularMadeTommy" style={{ color, display: 'inline-flex', alignItems: 'center', ...styles }}>
                {text}
                <span style={{ display: 'inline-flex' }}>
                    {Array.from({ length: dotCount }).map((_, i) => (
                        <span
                            key={i}
                            style={{
                                ...dotStyle,
                                animationDelay: `${i * 0.1}s`,
                            }}
                        >
                            .
                        </span>
                    ))}
                </span>
            </h5>
        </>
    );
};

export default LoadingDots;
